import styled from 'styled-components';

export const Container = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xl};
  padding: 0 ${({ theme }) => theme.spacing.md};
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  font-weight: 600;
  text-align: center;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: ${({ theme }) => theme.spacing.md};
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Button = styled.button`
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.background.primary}, ${({ theme }) => theme.colors.background.secondary});
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  padding: ${({ theme }) => theme.spacing.lg};
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.default};
  text-align: left;
  font-family: inherit;
  box-shadow: ${({ theme }) => theme.shadow.sm};
  position: relative;
  overflow: hidden;

  &:hover {
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.nia.primary}, ${({ theme }) => theme.colors.nia.secondary});
    color: white;
    border-color: ${({ theme }) => theme.colors.nia.primary};
    box-shadow: ${({ theme }) => theme.shadow.lg};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;
